import {useState} from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';

import { getCaseStatuses } from "../../helpers/selectOptions";
import { getCaseStatusOptions } from "../../helpers/cases";
import { useUpdateCaseMutation } from "../../redux/services/caseApi";
import CaseStatus from "./CaseStatus";
import CustomSelect from "../common/CustomSelect";
import './EditCaseStatus.css';

const handleChange = ({put, caseId, setSuccess}) => async e => {
  setSuccess(null);
  const value = e?.target?.value;
  const req = await put({id: caseId, body: {status: value}});
  if (req.data) setSuccess(true);
  if (req.error) setSuccess(false);
};

const EditCaseStatus = props => {
  const {case: c} = props;
  const [success, setSuccess] = useState(null);
  const [put] = useUpdateCaseMutation();
  const onChange = handleChange({caseId: c.id, put, setSuccess});
  const {Icon, color} = getCaseStatusOptions(c);
  return (
    <Stack direction='row' spacing={0.5} alignItems='center' className='EditCaseStatus'>
      <Icon 
        style={{
          color, 
          fontSize: '1.75em',
        }}
      />
      <CustomSelect 
        size='small'
        disableClearable
        style={{width: '115px'}}
        popupIcon={
          <KeyboardArrowDownIcon fill='#6F767E' sx={{fontSize: 2.25}}/>
        }
        defaultValue={c.status}
        options={getCaseStatuses()}
        onChange={onChange}
        renderValue={value => <CaseStatus case={c} />}
      />
      {
        success
        ? <CheckIcon color='success'/>
        : null
      }
      {
        success === false
        ? <CloseIcon color='error'/>
        : null
      }
    </Stack>
  );
};

export default EditCaseStatus;